<main>
  <section>
    <h3>3. Drag <small>Tab Headers</small></h3>
    <app-panel
      class="rounded border d-block p-3"
      [ngClass]="{ 'grey-background': !headerColumnRows.length }"
    >
      <div
        data-test-selector="headers-no-file-selected"
        class="no-file-selected"
        *ngIf="!headerColumnRows.length && !this.isLoading"
      >
        No File Selected
      </div>
      <div
        *appLoadingIndicator="{
          show: isLoading,
          showBackdrop: false,
          fullPage: false,
          message: 'Loading'
        }"
      ></div>

      <div
        data-test-selector="drag-columns-container"
        *ngIf="headerColumnRows.length > 0"
      >
        <select
          [ngModel]="selectedHeaderRowIndex"
          class="form-select form-select-sm"
          (change)="setSelectedHeaderRowIndex($event.currentTarget)"
        >
          <option value="" disabled>Select Headers Row</option>
          <option
            *ngFor="let headerRow of headerColumnRows; index as i"
            [ngValue]="headerRow.rowIndex"
            title="{{
              !headerColumnRows[i].headerColumns.length
                ? 'This row is empty.'
                : ''
            }}"
            [disabled]="!headerColumnRows[i].headerColumns.length"
          >
            Header Row {{ headerRow.rowIndex + 1 }}
          </option>
        </select>

        <div [dragula]="dragContainerName" class="draggable-headers-container">
          <ng-container
            *ngFor="
              let headerColumn of headerColumnRows[selectedHeaderRowIndex]
                .headerColumns
            "
          >
            <div
              [title]="headerColumn.columnHeader"
              *ngIf="isMappedColumn(headerColumn.columnHeader)"
              [attr.data-column-header]="headerColumn.columnHeader"
              class="btn ellipsis btn-primary draggable-header"
            >
              {{ headerColumn.columnHeader }}
            </div>
          </ng-container>
        </div>
      </div>
    </app-panel>
  </section>

  <section>
    <h3>4. Drop</h3>
    <app-panel
      class="rounded border d-block p-3"
      [ngClass]="{ 'grey-background': !headerColumnRows.length }"
    >
      <div
        data-test-selector="columns-no-file-selected"
        class="no-file-selected"
        *ngIf="!headerColumnRows.length && !isLoading"
      >
        No File Selected
      </div>
      <div
        *appLoadingIndicator="{
          show: isLoading,
          showBackdrop: false,
          fullPage: false,
          message: 'Loading'
        }"
      ></div>

      <div
        *ngIf="headerColumnRows.length"
        data-test-selector="assignable-fields-container"
        class="assignable-fields-container"
      >
        <div
          class="assignable-field"
          *ngFor="let assignableField of assignableFields"
        >
          <label class="ellipsis" [title]="assignableField.displayName">
            <small *ngIf="assignableField.required">*</small
            >{{ assignableField.displayName }}
          </label>

          <div
            class="drop-container rounded"
            [attr.data-assignable-field]="assignableField.name"
            [dragula]="dragContainerName"
          >
            <div
              [title]="mappedColumnFields.get(assignableField.name)"
              class="btn ellipsis btn-primary assigned-column"
              *ngIf="mappedColumnFields.get(assignableField.name)"
            >
              {{ mappedColumnFields.get(assignableField.name) }}
            </div>
          </div>
        </div>
      </div>
    </app-panel>
  </section>
</main>
